import { TextField } from '@mui/material'
import React, { Fragment } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Paper, Typography } from '@mui/material';
import { actualizaApoderadosCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../redux/AppDucks'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import TaskRoundedIcon from '@mui/icons-material/TaskRounded';
import estilos from './DatosGeneralesComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import moment from 'moment'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';


function ApoderadosLegalesComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const [editar, setEditar] = React.useState(false)

    const [representantelegal, setRepresentanteLegal] = React.useState(props?.data?.representantelegal?.toUpperCase())
    const [telefonorepresentante, setTelefono] = React.useState(props?.data?.telefonorepresentante)
    const [correoelectronicorepresentante, setCorreoElectronico] = React.useState(props?.data?.correoelectronicorepresentante?.toLowerCase())

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.apoderadoslegalesclientehistorial);
    const handleModalHistorial = () => { 
        setDataHistorial(props?.data?.apoderadoslegalesclientehistorial)
        setOpenModalHistorial(true) 
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 'fit-content',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
                            <h3 className='text-center'><b>ADVERTENCIA</b></h3>
                            <p className='mt-3'>¿Está seguro que desea actualizar la información del apoderado legal seleccionado?</p>
                        </Typography>
                        <br />
                        <ThemeProvider theme={theme}>
                            <div className='row'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }

    const btnContinuar = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        await dispatch(actualizarLoadingApp_true())
        let fechainscripcion = new Date(fechaHoy).toISOString()

        let dataActualizar = {
            datacambio:{representantelegal: representantelegal, telefonorepresentante: telefonorepresentante, correoelectronicorepresentante: correoelectronicorepresentante,
            idapoderadoslegales: props?.data?.idapoderadoslegales},idapoderadoslegales: props?.data?.idapoderadoslegales,usuariocambio: dataUser?.[0]?.usuario,
            fechacambio: fechainscripcion
        }
        await dispatch(actualizaApoderadosCliente(dataActualizar))
        handleCloseModal()
        props?.setIsEdicionApoderados(true)
        setEditar(false)
        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div style={{ border: '2px solid white', position: 'relative' }}>
                    <div className={`${estilos.tarjetaContacto}`} style={props?.data?.isbaja ? { border: '4px solid #DC3545' } : { border: '4px solid #8ABE3E' }}>
                        {!editar &&
                            <div>
                                {props?.data?.isbaja == false &&
                                    <div style={{ display: 'flex', justifyContent: 'end' }} >
                                        <Tooltip title="Ver historial de cambios">
                                            <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                }
                                {props?.data?.isbaja == true &&
                                    <div style={{ display: 'flex', justifyContent: 'end' }} >
                                            <IconButton size="large" sx={{ p: 1 }} disableFocusRipple disableRipple disabled >
                                                <HistoryRoundedIcon fontSize="inherit" sx={{ color: 'white' }} />
                                            </IconButton>
                                    </div>
                                }
                                <p style={{ marginTop: '3%', fontWeight: 'bold' }}> {props?.data?.isbaja ? 'INACTIVO' : 'ACTIVO'} </p>
                                <div className='row'>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><PersonRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                        {representantelegal}
                                    </div>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><CallRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                        {telefonorepresentante}
                                    </div>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><EmailRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                        {correoelectronicorepresentante}
                                    </div>
                                </div>
                                {!props?.data?.isbaja && dataUser?.[0]?.idrol == 1 && 
                                    <Button variant="contained" color="primary" style={{ width: '50%', marginTop: '3%' }} onClick={() => setEditar(true)}>Editar</Button>
                                }
                                {props?.data?.isbaja &&
                                    <Button variant="contained" color="primary" style={{ width: '50%', marginTop: '3%' }} disabled
                                        sx={{
                                            "&.Mui-disabled": {
                                                background: "#FFFFFF",
                                                color: "#FFFFFF",
                                                shadows: "none"
                                            }
                                        }}
                                    >Editar</Button>
                                }
                            </div>
                        }

                        {editar &&
                            <div style={{ paddingLeft: '1%', paddingRight: '1%' }}>
                                <p style={{ marginTop: '50px', fontWeight: 'bold' }}> {props?.data?.isbaja ? 'INACTIVO' : 'ACTIVO'} </p>
                                <div className='row'>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><PersonRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 justify-content-center'>
                                        <TextField id="standard-basic" variant="standard" value={representantelegal}
                                            onChange={e => setRepresentanteLegal(e.target.value?.toUpperCase())} fullWidth style={{ marginLeft: '3%' }} />
                                    </div>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><CallRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 justify-content-center'>
                                        <TextField id="standard-basic" variant="standard" value={telefonorepresentante}
                                            onChange={e => setTelefono(e.target.value)} fullWidth style={{ marginLeft: '3%' }} />
                                    </div>
                                    <div className='col-2 col-md-2 mt-1 text-end'>
                                        <p><EmailRoundedIcon /></p>
                                    </div>
                                    <div className='col-10 col-md-10 mt-1 pe-5 justify-content-center'>
                                        <TextField id="standard-basic" variant="standard" value={correoelectronicorepresentante}
                                            onChange={e => setCorreoElectronico(e.target.value?.toLowerCase())} fullWidth style={{ marginLeft: '3%', marginTop: '2%' }} />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-5 col-md-5' style={{ marginTop: '3%' }}>
                                        <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                                    </div>
                                    <div className='col-7 col-md-7' style={{ marginTop: '3%' }}>
                                        <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className={`${estilos.circuloContacto}`} style={props?.data?.isbaja ? { border: '4px solid #DC3545', backgroundColor: '#DC3545' } : { border: '4px solid #8ABE3E', backgroundColor: '#8ABE3E' }}>
                        <TaskRoundedIcon fontSize="large" style={{ fill: 'white' }} />
                    </div>
                </div>
            </ThemeProvider>

            {modalComponent()}
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Apoderado legal"} />}
        </Fragment >
    )
}

export default ApoderadosLegalesComponent